import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FeedKey, GetGroupFollowersDocument, Group, UserFeedFollow } from 'api';
import { Queries, ProfilesWidget } from 'components';

interface IProps {
  group: Group;
}

const Members: FC<IProps> = ({ group }) => {
  const { t } = useTranslation();
  const variables = { id: group.id, limit: 10, feed: FeedKey.Group };

  function renderList({ items, count }: Queries.IGetGroupFollowers) {
    if (!items.length) {
      return null;
    }

    return (
      <ProfilesWidget
        maxResults={8}
        maxWidth={170}
        link={`/group/${group.id}/members`}
        results={items.map((feedFollow: UserFeedFollow) => feedFollow.followed_by_user)}
        title={t('components:xMember', { count })}
        refetchQueries={[
          { query: GetGroupFollowersDocument, variables: { id: group.id, limit: 9 } },
        ]}
      />
    );
  }

  return (
    <Queries.GetGroupFollowers loader="widget" variables={variables}>
      {result => renderList(result)}
    </Queries.GetGroupFollowers>
  );
};

export default Members;
